import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  WritableSignal,
  inject,
} from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { NgClass, TitleCasePipe } from '@angular/common';
import { KeeniconComponent } from '../keenicon/keenicon.component';
import { ThemeModeService, ThemeModeType } from '../../services';

@Component({
  selector: 'ui-theme-mode-switcher',
  imports: [KeeniconComponent, NgbPopover, NgClass, TitleCasePipe],
  templateUrl: './theme-mode-switcher.component.html',
  styleUrl: './theme-mode-switcher.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeModeSwitcherComponent implements OnInit {
  private modeService = inject(ThemeModeService);

  menuMode!: WritableSignal<ThemeModeType>;

  ngOnInit() {
    this.menuMode = this.modeService.menuMode;
  }

  switchMode(mode: string) {
    this.modeService.switchMode(mode as ThemeModeType);
  }
}
